<template>
    <div :id="'product_card_'+product.code" class='card'>
        <a class='image-container' @click='productClick' :href="`/${this.product.category_url}${this.product.producturl}`">
            <!-- <div class='new-product'>New</div> -->
            <div class='favourite' :class="{'on-wishlist' : product.on_wishlist}" @click.stop='wishlistClick'><i class="fa-regular fa-heart"></i></div>
            <DynamicImageContainer class="product-image" :image='product.main_picture' :image_on_hover='product.second_picture' :show_different_image_on_hover='true' />
        </a>
        <div class='product-info'>
            <a class='product-link' @click='productClick' :href="`/${this.product.category_url}${this.product.producturl}`">
                <div class='product-header'>
                    <div class='heading'>{{product.product}}</div>
                    <div class='price'>£{{product.price}}</div>
                </div>
            </a>
            
            <ColourPicker size='small' :product='product' :page_builder_mode='page_builder_mode' />
        </div>

        
        <!-- <div class='bottom-container'>
            <input v-if='this.product.total_stock != 0' class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
            <div v-if='this.product.total_stock != 0' class='button'>
                <Button text='Add to cart' theme='green' @click='addToCart'/>
            </div>
            <div v-if='this.product.total_stock == 0' class='button'>
                <NotifyWhenAvailableButton/>
            </div>
        </div> -->

        <div :id='"page_number_"+product.page_number'></div>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue'
import {checkAuth} from "@/global/modules/functions.js";
import OutOfStockAlert from '@/ecom/components/cart/OutOfStockAlert.vue';
import NotifyWhenAvailableButton from '@/ecom/components/buttons/NotifyWhenAvailableButton.vue';
import ColourPicker from '@/ecom/components/products/single_product/attributes/ColourPicker.vue';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components:{Button, OutOfStockAlert, NotifyWhenAvailableButton, ColourPicker, DynamicImageContainer},
    emits: ['updatedCartListener', 'wishlistListener', 'cardClickedListener'],
    props: ['product', 'page_builder_mode'],
    data(){
        return{
            quantity: 1,
            stock: {}
        }
    },
    methods:{
        productClick(e){
            if(e.ctrlKey) {
                return;
            }
            else {
                e.preventDefault();
                
                if(!this.page_builder_mode){
                    this.$emit('cardClickedListener');
                    this.$router.push(`/${this.product.category_url}${this.product.producturl}`);
                }
            }
        },
        async wishlistClick(e){
            e.preventDefault();

            if(!this.page_builder_mode){
                let method = 'POST';

                if(this.product.on_wishlist){
                    method = 'DELETE'
                }

                let response = await fetch(`/api/wishlist`, {
                    method: method,
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                    product_id: this.product.code
                    }),    
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    if(!results.logged_in){
                        this.$router.push('/login');
                    }
                    else{
                        this.product.on_wishlist = !this.product.on_wishlist;
                        this.$emit('wishlistListener', this.product.code);
                    }
                }
            }
        },
        async addToCart(){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'increment_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.stock = results.stock;
                this.quantity = 1;
                this.$emit('updatedCartListener');
            }
        },
        blurQuantity(){
            if(isNaN(this.quantity) || this.quantity == ''){
                this.quantity = 1;
            }
        },
        async emailWhenBackInStock(){

        }
    }
}
</script>

<style lang="scss" scoped>

.card{
    display: flex;
    flex-direction: column;
    width: var(--product-card-width);
    cursor: pointer;
}

.product-info{
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-left: 5px;
    padding-right: 5px;
    text-decoration: none;
    color: #212529;
}

.product-link{
    text-decoration: none;
    color: #212529;
}
.product-header{
    display: flex;
    justify-content: space-between;
    color: var(--primary-colour-2);
}

.product-image{
    object-fit: cover;
    object-position: 50% 0;
    width: var(--product-card-width);
    height: var(--product-card-image-height);
}

.heading{
    font-size: 0.96rem;
    font-weight: 400;
    max-width: 214px;
}

.bottom-container{
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    height: 40px;
}

.button{
    // width: 100px;
    width: 100%;
    height: 100%;
}

.price{
    font-size: 0.96em;
    font-weight: 600;
}

.quantity-text-box{
    width: 40px;
    // padding: 3px;
   height: 38px;
    text-align: center;
    // border-radius: 4px;
    border-top: solid 1px #dee2e6;
    // border-bottom: solid 1px #adb5bd;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
}

.quantity-text-box{
    outline: none;
}


.image-container{
    position: relative;
}

.new-product{
    position: absolute;
    margin-top: 10px; 
    margin-left: 10px;
    border: solid 2px var(--black);
    padding: 2px 4px;
    font-weight: 600;
}

.favourite{
    position: absolute;
    right: 0;
    color: var(--black);

    margin-top: 8px; 
    margin-right: 10px;
    font-size: 1.4rem;
    // border: solid 2px var(--black);
    // padding: 2px 4px;
    // font-weight: 600;
}

.out-of-stock-container{
    // position: absolute;
    // margin-top: 40px;
    background-color: red;
    width: 100%;
    height: 100%;
}

.on-wishlist{
    color:#e03131;
}

</style>